<template >
    <div class="container-fluid" >

        <h3>Асуултууд</h3>
        <button class="btn btn-primary" @click="addQuestion">Асуулт нэмэх</button>
        
      <div v-if="questions!=null && questions.length>0">
        
      <div  class="card shadow mb-4" v-for="(question, index) in questions" v-bind:key="question.id">
        <div class="card-header py-3">
            <div class="row justify-content-between">
                <div class="col col-10"><h3 class="m-0 font-weight-bold text-primary">{{index+1}}.  {{question.name}}</h3></div>
                <div class="col col-md-auto">
                    <i class="fas fa-edit" @click="editQuestion(question)"></i>
                </div>
            </div>
          
          <p>{{question.description}}</p>
            <div class="row">
                <div class="col">
                    <span @click="_setLabel(question.id, false, 'public')" v-if="question.public==true" class="badge badge-danger">public</span>
                    <span @click="_setLabel(question.id, true, 'public')"  v-else class="badge badge-secondary">private</span>
                </div>
                <div class="col">
                    <span @click="_setLabel(question.id, true, 'closed')" v-if="question.closed!=true" class="badge badge-danger">open</span>
                    <span @click="_setLabel(question.id, false, 'closed')" v-else class="badge badge-secondary">closed</span>
                </div>
                <div class="col">
                    <span @click="_setLabel(question.id, true, 'showResult')" v-if="question.showResult!=true" class="badge badge-danger">hidden</span>
                    <span @click="_setLabel(question.id, false, 'showResult')" v-else class="badge badge-secondary">shown</span>
                </div>
            </div>

          <div class="my-4" v-if="question.answers!=null && question.answers.length>0">
            <h6>Хариултууд</h6>
            <ul class="list-group">
              <li v-for="(answer) in question.answers" v-bind:key="answer.id" class="list-group-item" >
                <div class="row"> 
                  <div class="col col-10">{{answer.name}}</div>
                  <div class="col col-2"><span class="badge badge-primary badge-pill">{{answer.votedCount}}</span></div>
                </div>
                
              </li>
            </ul>
            <div class="post" v-if="question.statData!=null && question.datacollection" >
                <bar-chart :chartData="question.datacollection" :options="options" ></bar-chart>
                
                <!-- <apexcharts  type="bar" :options="statData.chartOptions" :series="statData.series"></apexcharts> -->
            </div>
            <div v-else class="alert alert-success">
                Одоогоор энэ асуултанд хүн хариулаагүй байна.
            </div>
          </div>
          <div v-else class="alert alert-success">
                Одоогоор энэ асуултанд хариулт оруулаагүй байна.
            </div>
        </div>
        
      </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
 import BarChart from './BarChart.js'
import { stat } from 'fs';
 var colors=['#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'];
export default {
    name: "Questions",
    components: {
        BarChart
    },
    data() {
        return {
            questions:[],
            options:{
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true
                        }
                    }]
                }
            },
            statData:{
                    chartOptions: {
                        chart: {
                            id: 'basic-bar'
                        },
                        colors: colors,
                        labels:{
                            show:true,
                            hideOverlappingLabels:false
                        },
                        plotOptions: {
                            bar: {
                                distributed: true,
                                horizontal:true,
                                endingShape:'rounded'
                            }
                        }
                        // plotOptions: {
                        //     bar: {
                        //     horizontal: false,
                        //     columnWidth: '55%',
                        //     endingShape: 'rounded'	
                        //     },
                        // },
                    },
                    series: [{
                        name: 'series-1',
                        data: [{
                            x: 'Apple',
                            y: 54
                        }, {
                            x: 'Orange',
                            y: 66
                        }],
                    }]
                },
                
            
        };
    },
    methods: {
        
      _getQA(){
     
     console.log("dsfsf")
        fb.db.collection("asuulga/"+this.qaId+"/questions").onSnapshot(querySnapshot=> {
            this.questions=[]
            querySnapshot.forEach(doc=> {
             
                let object=doc.data()
                object.id = doc.id
                object.statData=null
                object.datacollection=null
                object.answers=[]
                this._getAnswers(object, doc.ref)
                this.questions.push(object);
            });
        
        });
              
    
          

      },
       _getAnswers(question, ref){
            if(question.answers==null || question.answers==undefined)
                question.answers=[];
            ref.collection("answers").onSnapshot(querySnapshot=> {
                question.answers=[];
                let labels=[]
                let dataset=[
                    {
                        label: 'A',
                        backgroundColor: '#f87979',
                        data: [],
                        backgroundColor:[]
                    }
                ]
                let data=[]
                let index=0;
                let answered=false
                querySnapshot.forEach(doc=> {
                    let answer=doc.data()
                        answer.id = doc.id
                    if(answer.votedCount!=null && answer.votedCount>0)
                      answered=true;
                        labels.push(answer.name)
                        dataset[0].data.push(answer.votedCount);
                        dataset[0].backgroundColor.push(index<=colors.length? colors[index]:this.getRandomColor());
                        data.push({x: answer.name, y: answer.votedCount, color: this.getRandomColor()})

                        question.answers.push(answer);
                        index++
                });
                if(answered==true){
                  question.statData=this.statData
                  question.datacollection={
                      labels: labels,
                      datasets: dataset
                  }
                    // this.statData.chartOptions.xaxis.categories=labels
                    question.statData.series=[{
                        name: 'санал',
                        data: data
                    }]
                }
                else{
                  question.datacollection=null
                  question.statData=null
                }
            });

        },
         getRandomInt () {
            return Math.floor(Math.random() * (50 - 5 + 1)) + 5
        },
        getRandomColor() {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        editQuestion(question){
            this.$router.push({ name: 'QuestionAdd', params: { questionId: question.id} })
        },
        addQuestion(){
            this.$router.push({ name: 'QuestionAdd', params: { questionId: 'new'} })
        },
        _setLabel(questionId, status, field){
            var tmp={}
            tmp[field]=status;
            fb.db.collection("asuulga").doc(this.qaId).collection("questions").doc(questionId).update(tmp)
        }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },

    props: {
        qaId: { 
            required: false,
        },
       
    
    },
    created() {
      if(this.qaId!=null && this.qaId!=''){
        this._getQA()
      }
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

